// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SellingProduct_button__cvWat{
    background-color: #FF6500;
    color: white;
    padding: 10px 20px;
    font-family: Poppins;
    margin-bottom: 1rem;
    font-size: 14px;
    border: none;
    border-radius: 10px;
    cursor: pointer;
}
.SellingProduct_hero__hhRkc{
    margin-left: 6rem;
}
.SellingProduct_heroImage__KFpor{
    height: 500px;
    width: 500px;
}
.SellingProduct_heading__5r6sh{
    margin-top: 7.5rem;
    font-family: Poppins;
    font-weight: 500;
    font-size: 36px;
}
.SellingProduct_highlight__lfh6Y{
    color: #FF6500;
}
.SellingProduct_text__TRICP{
    color: #667085;
    font-family: Poppins;
    font-weight: 400;
    font-size: 16px;
    margin-bottom: 1rem;
}
@media (min-width: 300px) and (max-width: 400px) {
    .SellingProduct_hero__hhRkc{
        margin-left: 0px;
        width: 387px;
        /* background-color: black; */
    }
    .SellingProduct_heading__5r6sh{
        margin-top: 0px;
        margin-left: 12px;
        font-size: 30px;
    }
    .SellingProduct_text__TRICP{
        margin-left: 12px;
    }
    .SellingProduct_button__cvWat{
        margin-left: 12px;
    }
    .SellingProduct_heroImage__KFpor{
        height: 408px;
        width: 364px;
    }
}
@media (min-width: 400px)  and (max-width: 600px) {
    .SellingProduct_hero__hhRkc{
        margin-left: 0px;
        width: 432px;
        /* background-color: black; */
    }
    .SellingProduct_heading__5r6sh{
        margin-top: 0px;
        margin-left: 18px;
        font-size: 30px;
    }
    .SellingProduct_text__TRICP{
        margin-left: 18px;
    }
    .SellingProduct_button__cvWat{
        margin-left: 18px;
    }
    .SellingProduct_heroImage__KFpor{
        height: 500px;
        width: 419px;
    }
  }
  @media (min-width: 600px) and (max-width: 1024px) {
    .SellingProduct_hero__hhRkc{
        margin-left: 0rem;
    }
  }`, "",{"version":3,"sources":["webpack://./src/Pages/SellingProduct.module.css"],"names":[],"mappings":"AAAA;IACI,yBAAyB;IACzB,YAAY;IACZ,kBAAkB;IAClB,oBAAoB;IACpB,mBAAmB;IACnB,eAAe;IACf,YAAY;IACZ,mBAAmB;IACnB,eAAe;AACnB;AACA;IACI,iBAAiB;AACrB;AACA;IACI,aAAa;IACb,YAAY;AAChB;AACA;IACI,kBAAkB;IAClB,oBAAoB;IACpB,gBAAgB;IAChB,eAAe;AACnB;AACA;IACI,cAAc;AAClB;AACA;IACI,cAAc;IACd,oBAAoB;IACpB,gBAAgB;IAChB,eAAe;IACf,mBAAmB;AACvB;AACA;IACI;QACI,gBAAgB;QAChB,YAAY;QACZ,6BAA6B;IACjC;IACA;QACI,eAAe;QACf,iBAAiB;QACjB,eAAe;IACnB;IACA;QACI,iBAAiB;IACrB;IACA;QACI,iBAAiB;IACrB;IACA;QACI,aAAa;QACb,YAAY;IAChB;AACJ;AACA;IACI;QACI,gBAAgB;QAChB,YAAY;QACZ,6BAA6B;IACjC;IACA;QACI,eAAe;QACf,iBAAiB;QACjB,eAAe;IACnB;IACA;QACI,iBAAiB;IACrB;IACA;QACI,iBAAiB;IACrB;IACA;QACI,aAAa;QACb,YAAY;IAChB;EACF;EACA;IACE;QACI,iBAAiB;IACrB;EACF","sourcesContent":[".button{\n    background-color: #FF6500;\n    color: white;\n    padding: 10px 20px;\n    font-family: Poppins;\n    margin-bottom: 1rem;\n    font-size: 14px;\n    border: none;\n    border-radius: 10px;\n    cursor: pointer;\n}\n.hero{\n    margin-left: 6rem;\n}\n.heroImage{\n    height: 500px;\n    width: 500px;\n}\n.heading{\n    margin-top: 7.5rem;\n    font-family: Poppins;\n    font-weight: 500;\n    font-size: 36px;\n}\n.highlight{\n    color: #FF6500;\n}\n.text{\n    color: #667085;\n    font-family: Poppins;\n    font-weight: 400;\n    font-size: 16px;\n    margin-bottom: 1rem;\n}\n@media (min-width: 300px) and (max-width: 400px) {\n    .hero{\n        margin-left: 0px;\n        width: 387px;\n        /* background-color: black; */\n    }\n    .heading{\n        margin-top: 0px;\n        margin-left: 12px;\n        font-size: 30px;\n    }\n    .text{\n        margin-left: 12px;\n    }\n    .button{\n        margin-left: 12px;\n    }\n    .heroImage{\n        height: 408px;\n        width: 364px;\n    }\n}\n@media (min-width: 400px)  and (max-width: 600px) {\n    .hero{\n        margin-left: 0px;\n        width: 432px;\n        /* background-color: black; */\n    }\n    .heading{\n        margin-top: 0px;\n        margin-left: 18px;\n        font-size: 30px;\n    }\n    .text{\n        margin-left: 18px;\n    }\n    .button{\n        margin-left: 18px;\n    }\n    .heroImage{\n        height: 500px;\n        width: 419px;\n    }\n  }\n  @media (min-width: 600px) and (max-width: 1024px) {\n    .hero{\n        margin-left: 0rem;\n    }\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"button": `SellingProduct_button__cvWat`,
	"hero": `SellingProduct_hero__hhRkc`,
	"heroImage": `SellingProduct_heroImage__KFpor`,
	"heading": `SellingProduct_heading__5r6sh`,
	"highlight": `SellingProduct_highlight__lfh6Y`,
	"text": `SellingProduct_text__TRICP`
};
export default ___CSS_LOADER_EXPORT___;
